const serviceController = {
   tabs: document.querySelectorAll('.services__tab-item'),
   tabContent: document.querySelectorAll('.services__cards'),
   cards: document.querySelectorAll('a[data-modal-service="true"]'),
   init() {
      this.handleResize();
      window.addEventListener('resize', () => this.handleResize());
      this.switchTab();
      this.openModal();
   },
   handleResize() {
      if(window.innerWidth >= 992) {
         const firstTab = this.tabs[0];
         const firstContent = this.tabContent[0];

         this.tabs.forEach(eachElement => {
            eachElement.classList.remove('services__tab-item--active');
            eachElement.setAttribute('aria-selected', false);
            eachElement.setAttribute('tabindex', '-1');
         });

         this.tabContent.forEach(eachContent => {
            eachContent.classList.remove('services__cards--active');
            eachContent.setAttribute('hidden', true);
            eachContent.setAttribute('tabindex', '-1');
         });

         //ativando o primeiro
         firstTab.classList.add('services__tab-item--active');
         firstTab.setAttribute('aria-selected', true);
         firstTab.setAttribute('tabindex', '0');

         firstContent.classList.add('services__cards--active');
         firstContent.removeAttribute('hidden')
         firstContent.setAttribute('tabindex', '0');
      } else {
         this.tabs.forEach(eachElement => {
            eachElement.classList.remove('services__tab-item--active');
            eachElement.setAttribute('aria-selected', false);
            eachElement.setAttribute('tabindex', '-1');
         });

         this.tabContent.forEach(eachContent => {
            eachContent.classList.remove('services__cards--active');
            eachContent.setAttribute('hidden', true);
            eachContent.setAttribute('tabindex', '-1');
         });
      }
   },
   switchTab() {
      this.tabs.forEach(element => {
         element.addEventListener('click', event => {
            event.preventDefault();

            const tabName = element.getAttribute('id');
            const btnOpen = element.classList.contains('services__tab-item--active');

            // Remover 'active' de todos botoes
            this.tabs.forEach(eachElement => {
               eachElement.classList.remove('services__tab-item--active');
               eachElement.setAttribute('aria-selected', false);
               eachElement.setAttribute('tabindex', '-1');
            });

            // Elemento Atual Clicado, adicionar 'active'
            if (btnOpen) {
               element.classList.remove('services__tab-item--active');
               element.setAttribute('aria-selected', false);
               element.setAttribute('tabindex', '-1');
            } else {
               element.classList.add('services__tab-item--active');
               element.setAttribute('aria-selected', true);
               element.setAttribute('tabindex', '0');
            }

            // Divs dos conteudos
            this.tabContent.forEach(eachContent => {
               if (eachContent.matches(`[aria-labelledby="${tabName}"]`)) {
                  if (['services__cards--active'].some(className => eachContent.classList.contains('services__cards--active'))) {
                     eachContent.classList.remove('services__cards--active');
                     eachContent.setAttribute('hidden', true);
                     eachContent.setAttribute('tabindex', '-1');
                  } else {
                     eachContent.classList.add('services__cards--active');
                     eachContent.setAttribute('hidden', false);
                     eachContent.setAttribute('tabindex', '0');
                  }
               } else {
                  eachContent.classList.remove('services__cards--active');
                  eachContent.setAttribute('hidden', true);
                  eachContent.setAttribute('tabindex', '-1');
               }
            });
         });
      });
   },
   openModal() {
      this.cards.forEach(card => {
         card.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const text = card.querySelector('.services__card-description').textContent;
            document.querySelector('.service-modal__title').textContent = text;
            MicroModal.show('modal-service');
         });
      });
   },
};

serviceController.init();
